module.exports = __webpack_public_path__ + "static/media/top-bar-battles-timer-backing.d2fa4aae.png";